import { UserService } from "../../services/user.service"
import { Component, OnInit } from "@angular/core"

@Component({
    selector: "app-available-features",
    templateUrl: "./available-features.component.html",
    styleUrls: ["./available-features.component.less"],
})
export class AvailableFeaturesComponent {
    public googleClassroomIcon: string = ""
    constructor(public userService: UserService) {
        this.googleClassroomIcon = require("../../../assets/google_classroom_grey_stroke_icon.png")
    }
}
